import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useMatchingQuery = (careerId, userId, options = {}) => {
  return useQuery({
    queryKey: QUERY_KEYS.matchingByCareerAndUser(careerId, userId),
    queryFn: async () => {
      const response = await query({
        query: 'matchMeIfYouCan',
        variables: { career_id: careerId, user_id: userId }
      })

      if (!response || response === 'undefined') {
        console.error('useMatchingQuery: Invalid response received:', response)
        throw new Error('Invalid response from matchMeIfYouCan query')
      }

      try {
        const parsed = JSON.parse(response)
        return parsed[0]
      } catch (error) {
        console.error(
          'useMatchingQuery: JSON parse error:',
          error,
          'Response:',
          response
        )
        throw new Error(`Failed to parse matching response: ${error.message}`)
      }
    },
    enabled: !!(careerId && userId),
    ...options
  })
}
